export interface ExperimentData {
  name: string
}

export enum EXPERIMENTNAME {
  progressBarWithCar = 'new-application-form_car-v1',
  isReapply = 'new-application-form_reapply-v1',
  addressRedesignV2 = 'new-application-form_address-redesign-v2',
  isTrustpilotV1 = 'new-application-form_tp-v1',
  isTrustpilotV1crm = 'new-application-form_tp-v1-crm',
  isTrustpilotV1digi = 'new-application-form_tp-v1-digi',
  isTrustpilotV1at = 'new-application-form_tp-v1-at',
  digiLandingPageV1 = 'new-application-form_digi-lp-v1',
  firstTimeApplicantPreInterstitialV1 = 'new-application-form_fta-pre-int-v1',
  vehicleImgV1 = 'new-application-form_vehicle-image-v1',
  requiredDetailsV1 = 'new-application-form_rd-v1',
  bouncerV1 = 'new-application-form_bcr-v1',
  colorVariationV1 = 'new-application-form_colors-v1',
  formlessJourneyV1 = 'new-application-form_formless-v1',
  formlessJourneyV3_clearscore = 'new-application-form_formless-v3-cs',
  formlessJourneyV3_experian = 'new-application-form_formless-v3-exp',
  formlessJourneyV3_carmoola = 'new-application-form_formless-v3-cml',
  atLandingPageV6 = 'new-application-form_at-lp-v6',
  atLandingPageV5 = 'new-application-form_at-lp-v5',
  atLandingPageV4 = 'new-application-form_at-lp-v4',
  questionCopyChangeV1 = 'new-application-form_qu-copy-v1',
  reviewPageV4 = 'new-application-form_review-page-v4',
  reviewPageV3PreApproval = 'new-application-form_review-page-v3-preapproved',
  reviewPageV3 = 'new-application-form_review-page-v3',
  inputIconsV1 = 'new-application-form_input-icons-v1',
  interstitialV1 = 'new-application-form_int-v1',
  removeContinueCtaV1 = 'new-application-form_r-cta-v1',
  personalDetailsV4_2 = 'new-application-form_pd-v4-2',
  resumeV1 = 'new-application-form_resume-v1',
  msmThemeV1 = 'new-application-form_msm-theme-v1',
  shouldRenderMSMInterstitial = 'new-application-form_msm-int',
  bouncerV1at = 'new-application-form_bcr-v1-at',
  bouncerV1aff = 'new-application-form_bcr-v1-aff',
  marketingOptInV1 = 'new-application-form_optin-v1'
}
